import { render, staticRenderFns } from "./TellusWidget.vue?vue&type=template&id=c23dde72&scoped=true&"
import script from "./TellusWidget.vue?vue&type=script&lang=ts&"
export * from "./TellusWidget.vue?vue&type=script&lang=ts&"
import style0 from "./TellusWidget.vue?vue&type=style&index=0&id=c23dde72&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23dde72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VIcon,VNavigationDrawer,VProgressCircular})
